import React, { useState } from 'react';

const FooterForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    fname: '',
    lname: '',
    role: 'Educator',
    success: false,
    _wpcf7_unit_tag: 'wpcf7-f' + '4958' + '-123'
  });

  const handleInputChange = event => {
    const { name, value } = event.target;
    console.log(name);
    console.log(value);

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = event => {
    event.preventDefault();
    const formEndpoint =
      'https://backend-api.worldsavvy.org/wp-json/contact-form-7/v1/contact-forms/4958/feedback';
    const body = new FormData(document.getElementById('footerform'));
    console.log(formData);
    Object.entries(formData).forEach(([key, value]) => {
      body.append(key, value);
    });

    fetch(formEndpoint, {
      method: 'POST',
      body: body,
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setFormData({
          email: '',
          role: 'Educator',
          fname: '',
          lname: '',
          submitting: false,
          success: true,
          _wpcf7_unit_tag: 'wpcf7-f' + '4958' + '-123'
        });
      });
  };

  return (
    <form id='footerform' onSubmit={handleSubmit} name='footerform'>
      <p>
        <strong>I am a/n:</strong>
      </p>
      <ul className='radio-check-list'>
        <li>
          <input
            type='radio'
            value='Educator'
            id='educator1'
            checked={formData.role === 'Educator'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='educator1'>Educator</label>
        </li>
        <li>
          <input
            type='radio'
            value='School Leader'
            checked={formData.role === 'School Leader'}
            onChange={handleInputChange}
            id='school_leader1'
            name='role'
          />
          <label htmlFor='school_leader1'>School Leader</label>
        </li>
        <li>
          <input
            type='radio'
            value='Donor'
            id='donor1'
            checked={formData.role === 'Donor'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='donor1'>Donor</label>
        </li>
        <li>
          <input
            type='radio'
            value='Other'
            id='other1'
            checked={formData.role === 'Other'}
            onChange={handleInputChange}
            name='role'
          />
          <label htmlFor='other1'>Other</label>
        </li>
      </ul>
      <div className='form-group'>
        <input
          type='text'
          name='fname'
          className='form-control'
          placeholder='First Name'
          value={formData.fname}
          onChange={handleInputChange}
        />
      </div>
      <div className='form-group'>
        <input
          type='text'
          name='lname'
          className='form-control'
          placeholder='Last Name'
          value={formData.lname}
          onChange={handleInputChange}
        />
      </div>
      <div className='form-group'>
        <input
          type='email'
          name='email'
          className='form-control'
          placeholder='Email *'
          value={formData.email}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className='form-group'>
        <input className='btn white-btn' type='submit' value='Submit' />
        {formData.success && (
          <p id='footer-form' style={{ color: 'black' }}>
            Form submitted successfully!
          </p>
        )}
      </div>
    </form>
  );
};

export default FooterForm;
